<div class="dialog-container">
  <div class="loader" *ngIf="isLoading">
    <mat-spinner class="rfq-spinner"></mat-spinner>
  </div>
  <div class="header-dialog">
    <h1 mat-dialog-title>Assign Contracting Executive</h1>
  </div>
  <div mat-dialog-content>
    <div>
        <div *ngIf="currentCE">
            <p><b>You have already assigned {{currentCE.value}} to this tender</b></p>
            <p><b>If you wish to assign another contracting executive, please select another personnel.</b></p>
        </div>
        <p> <b>Contracting Executive<span class="asterisk">*</span></b></p>
        <ng-select
        class="select-dropdown" 
        bindLabel="value"
        appearance="outline" 
        [items]="CEList"
        [(ngModel)]="selectedCE"
        placeholder="Please select an option"
        appendTo="body"
        >
        </ng-select>
    </div>
    <div>
    <p class="assistive-text">The personnel who will manage the current tender.</p>
    <p *ngIf="isErr" class="err-message">{{errorMessage}}</p>
    </div>
  </div>
  <div mat-dialog-actions>
    <app-button class="mar-r-10" name="Cancel" (click)="close()"></app-button>
    <app-button  name="Assign" type="flat-button" [disabled]="isLoading" (click)="!isLoading && updateAssignedCE()"></app-button>
  </div>
</div>
